import React, { useState, useEffect } from "react";
import $ from "jquery";
import "./App.css";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import About from "./Components/About";
import Resume from "./Components/Resume";
import Portfolio from "./Components/Portfolio";

const App = () => {
  const [resumeData, setResumeData] = useState({});
  const [lang, setLang] = useState("");

  useEffect(() => {
    $.ajax({
      url: "./resumeData.json",
      dataType: "json",
      cache: false,
      success: function (data) {
        setResumeData(data);
      },
      error: function (xhr, status, err) {
        console.log(err);
        alert(err);
      },
    });
  }, []);

  return (
    <div className="App">
      <Header data={resumeData.main} setLanguage={setLang} />
      <About data={resumeData.main} language={lang} />
      <Resume data={resumeData.resume} dataInd={resumeData?.resumeIndonesian} language={lang} />
      <Portfolio data={resumeData.portfolio} language={lang} />
      <Footer data={resumeData.main} language={lang} />
    </div>
  );
};

export default App;
